import React, { forwardRef } from 'react'
import classnames from 'classnames'

interface Props {
  className?: string
  id?: string
  title?: React.ReactNode
  subTitle?: React.ReactNode
  subTitleElementType?: string
  headingLevel?: number
  hideBorder?: boolean
}

const BoxContainer = forwardRef<HTMLDivElement, Props & React.HTMLProps<HTMLDivElement>>(
  (
    {
      className,
      id,
      title,
      subTitle,
      subTitleElementType = 'em',
      headingLevel = 2,
      hideBorder,
      children,
    },
    ref
  ) => {
    const buildTitle = () => {
      const reactElementType = headingLevel <= 6 ? `h${headingLevel}` : 'h6'
      let content: Array<string | React.ReactNode> = [title]
      if (subTitle) {
        content = [
          title,
          React.createElement(
            subTitleElementType,
            { key: 'subtitle', className: 'row-box-container-subtitle' },
            subTitle
          ),
        ]
      }
      return React.createElement(
        reactElementType,
        { key: 'title', className: 'row-box-container-title' },
        content
      )
    }

    return (
      <div
        ref={ref}
        className={`row-box-container ${classnames(className, { 'hide-border': hideBorder })}`}
        id={id}
      >
        {title && buildTitle()}
        <div className='row-box-container-content'>{children}</div>
      </div>
    )
  }
)

BoxContainer.displayName = 'BoxContainer'
export default BoxContainer
